import { StateController } from 'state-controller';
import { AppState } from 'redux/store';
import { FailReasonsModel } from 'services/production-task.model';

export type ConfirmationWindowStateT = {
  reasonForReopening: string;
  reasonOptions: FailReasonsModel[];
  selectedReasonOptions: FailReasonsModel[];
};

const defaultState: ConfirmationWindowStateT = {
  reasonOptions: [],
  reasonForReopening: '',
  selectedReasonOptions: [],
};

const stateController = new StateController<ConfirmationWindowStateT>('CONFIRMATION_WINDOW_STATE', defaultState);

export class Actions {
  public static disposeState() {
    return (dispatch) => {
      dispatch(
        stateController.setState((prevState) => ({
          ...prevState,
          reasonForReopening: '',
          selectedReasonOptions: [],
        })),
      );
    };
  }

  public static setReasonOptions(reasonOptions: FailReasonsModel[]) {
    return (dispatch) => {
      dispatch(
        stateController.setState((prevState) => ({
          ...prevState,
          reasonOptions,
        })),
      );
    };
  }

  public static onReasonChange(newReason: string) {
    return (dispatch) => {
      dispatch(
        stateController.setState((prevState) => ({
          ...prevState,
          reasonForReopening: newReason,
        })),
      );
    };
  }

  public static onReasonParametersChange(newId: string) {
    return (dispatch, getState: () => AppState) => {
      const { reasonOptions, selectedReasonOptions } = getState().confirmation_window;

      const selectedReasonOption = reasonOptions.find((option) => option.id === newId);

      const alreadySelected = selectedReasonOptions.some((option) => option.id === newId);

      const updatedSelectedOptions = alreadySelected
        ? selectedReasonOptions.filter((option) => option.id !== newId)
        : [...selectedReasonOptions, selectedReasonOption];

      dispatch(
        stateController.setState((prevState) => ({
          ...prevState,
          selectedReasonOptions: updatedSelectedOptions,
        })),
      );
    };
  }
}

export const reducer = stateController.getReducer();
